export default __webpack_public_path__ + "28da44bdb5a202528bf7145e47c499db.png";